import React, { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { reduxForm, Field, FieldArray } from "redux-form";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import Tooltip from "@material-ui/core/Tooltip";
import RemoveIcon from "@material-ui/icons/Remove";
import CircularProgress from "@material-ui/core/CircularProgress";

import { history } from "../../../../routes/index";
import useStyles from "./styles";
import CustomTextField from "../../../../components/CustomTextField";
import CustomCheckboxField from "../../../../components/CustomCheckboxField";
import CustomSnackbar from "../../../../components/CustomSnackbar";
import userFormValidate from "../../../../validators/userFormValidate";
import ContentCheckBoxField from "../../ContentCheckBoxField";

let UserForm = ({ handleSubmit, textFields, parentSubmitHandle, valid }) => {
  const classes = useStyles();

  const previousRoute = useSelector((state) => state.route.previousRoute);
  const userLoading = useSelector((state) => state.users.loading);
  const roles = useSelector((state) => state.roles.data);
  const units = useSelector((state) => state.units.data);
  const groups = useSelector((state) => state.groups.data);

  const renderTextFields = useCallback(
    () =>
      textFields.map((field, index) => (
        <Grid item xs={12} sm={6} key={index}>
          <Field
            component={CustomTextField}
            name={field.name}
            label={field.label}
            isPassword={field.isPassword}
          />
        </Grid>
      )),
    [textFields]
  );

  const renderPhoneFields = useCallback(({ fields }) => {
    return (
      <>
        {fields.getAll() &&
          fields.map((field, index) => {
            return (
              <Grid
                item
                sm={12}
                key={index}
                style={{ display: "flex", gap: 16 }}
              >
                <Field
                  name={`${field}.number`}
                  label={`Telefone ${index + 1}`}
                  adornment={
                    <Tooltip title="Remover telefone" aria-label="remove">
                      <RemoveIcon fontSize="small" />
                    </Tooltip>
                  }
                  parentAdornmentHandleClick={() => fields.remove(index)}
                  component={CustomTextField}
                />
                <Field
                  name={`${field}.smsSmn`}
                  component={CustomCheckboxField}
                  label="SMN"
                />
              </Grid>
            );
          })}

        {fields.length < 4 && (
          <Grid
            item
            xs={12}
            sm={6}
            container
            justify="center"
            alignItems="center"
          >
            <Button
              color="secondary"
              startIcon={<AddIcon />}
              onClick={() => fields.push("")}
            >
              Adicionar telefone
            </Button>
          </Grid>
        )}
      </>
    );
  }, []);

  return (
    <Grid
      container
      component="form"
      classes={{ root: classes.formContainer }}
      onSubmit={handleSubmit(parentSubmitHandle)}
    >
      <Grid item xs={12} md={6} classes={{ root: classes.formLeftSide }}>
        <Box className={classes.formSubtitleContainer}>
          <Typography classes={{ root: classes.formSubtitle }}>
            Entre com os dados do usuário
          </Typography>
        </Box>

        <Divider />

        <Box classes={{ root: classes.fieldsContainer }}>
          <Grid container spacing={3} style={{ marginBottom: 8 }}>
            {renderTextFields()}
            <FieldArray name="phones" component={renderPhoneFields} />
          </Grid>
          <Field
            name="usesClientIntegration"
            component={CustomCheckboxField}
            label="Habilitar integração"
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={6} classes={{ root: classes.formRightSide }}>
        <ContentCheckBoxField
          title=" Selecione os cargos a serem atribuídos ao usuário"
          emptyMessage="Não há cargos disponíveis para o cliente selecionado"
          field="roles"
          loading={false}
          data={roles}
          labelKey="label"
        />
      </Grid>
      <Grid item xs={12} md={6} classes={{ root: classes.formLeftSide }}>
        <ContentCheckBoxField
          title="Selecione as unidades a serem atribuídos ao usuário"
          emptyMessage="Não há unidades disponíveis para o cliente selecionado"
          field="units"
          loading={false}
          data={units}
          labelKey="unitName"
        />
      </Grid>
      <Grid item xs={12} md={6} classes={{ root: classes.formRightSide }}>
        <ContentCheckBoxField
          title="Selecione os grupos a serem atribuídos ao usuário"
          emptyMessage="Não há grupos disponíveis para o cliente selecionado"
          field="groups"
          loading={false}
          data={groups}
          labelKey="groupName"
        />
      </Grid>
      <Grid item xs={12} container justify="center">
        <Grid item xs={6} classes={{ root: classes.buttonContainer }}>
          <Button
            variant="outlined"
            color="secondary"
            style={{ marginRight: 20 }}
            classes={{ root: classes.button }}
            onClick={() => history.push(previousRoute)}
          >
            <Typography color="secondary" variant="button">
              Cancelar
            </Typography>
          </Button>
          <Button
            variant="contained"
            color={!userLoading ? "secondary" : "default"}
            type="submit"
            disabled={!valid}
            classes={{ root: classes.button }}
          >
            {userLoading && (
              <>
                <CircularProgress
                  color="secondary"
                  size={20}
                  style={{ marginRight: 7 }}
                />
                <Typography color="secondary" variant="button">
                  Salvando
                </Typography>
              </>
            )}
            {!userLoading && <Typography variant="button">Salvar</Typography>}
          </Button>
        </Grid>
      </Grid>

      <CustomSnackbar variant="error" />
    </Grid>
  );
};

export default reduxForm({
  form: "user",
  validate: userFormValidate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(UserForm);
